export default function Consulting() {
  return (
    <section
      id="consulting"
      className="relative py-48 overflow-hidden"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/438dc3d5f7d3c25fb248c8a9d38b9b63.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="mb-6">
              <span className="inline-block px-4 py-2 bg-amber-500/20 backdrop-blur-sm text-amber-300 text-xs font-semibold uppercase tracking-wider rounded-full border border-amber-500/30">
                Coming Soon
              </span>
            </div>
            <h2 className="text-6xl lg:text-7xl font-bold text-white mb-8 leading-tight">
              1:1 맞춤
              <br />
              컨설팅
            </h2>
            <button className="group inline-flex items-center space-x-4 bg-white text-gray-900 px-8 py-4 rounded-full font-medium hover:bg-gray-100 transition-all duration-300 hover:shadow-xl whitespace-nowrap cursor-pointer">
              <span>사전 신청하기</span>
              <div className="w-10 h-10 flex items-center justify-center bg-gray-900 rounded-full">
                <i className="ri-arrow-right-line text-white group-hover:translate-x-1 transition-transform"></i>
              </div>
            </button>
          </div>

          <div className="flex justify-end">
            <div className="text-right">
              <p className="text-white text-2xl font-light leading-relaxed">
                당신의 커리어 목표에 맞춘
                <br />
                전략적 가이드
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
